<template>
  <div class="registration-page">
    <el-card class="box-card" shadow="hover">
      <!-- 头部标题 -->
      <div slot="header" class="clearfix header-box">
        <h2>上海国际设计周设计选材展・家装节 门票免费申领</h2>
        <span class="sub-title">请完善以下信息以完成入场预约</span>
      </div>

      <el-form ref="regForm" :model="formData" :rules="rules" label-position="top" size="medium">

        <!-- ================= 第一部分：基础实名信息 (对应截图) ================= -->
        <div class="section-title">个人身份信息</div>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="formData.name" placeholder="请输入您的真实姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="formData.phone" placeholder="请输入11位手机号">
                <el-button slot="append" @click="getCode" :disabled="isCountingDown" style="width: 120px;">
                  {{ isCountingDown ? countdown + 's后重发' : '获取验证码' }}
                </el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item label="验证码" prop="code">
              <el-input v-model="formData.code" placeholder="请输入短信验证码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="formData.idCard" placeholder="用于现场核验身份"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="公司名称" prop="company">
          <el-input v-model="formData.company" placeholder="请输入单位全称"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12">
            <el-form-item label="职务" prop="jobTitle">
              <el-input v-model="formData.jobTitle" placeholder="例如：设计总监、采购经理"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="formData.address" placeholder="省/市/区/街道"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ================= 第二部分：展会调研问卷 (最新内容) ================= -->
        <div class="section-title mt-40">观展意向调研</div>

        <!-- 1. 身份类型 -->
        <el-form-item label="1. 您的身份类型" prop="identity">
          <el-select v-model="formData.identity" placeholder="请选择您的身份" style="width: 100%;">
            <el-option label="设计师（室内/软装/建筑/视觉/工业设计）"
                       value="设计师（室内/软装/建筑/视觉/工业设计）"></el-option>
            <el-option label="设计行业从业者/品牌商家" value="设计行业从业者/品牌商家"></el-option>
            <el-option label="高校设计相关专业学生" value="高校设计相关专业学生"></el-option>
            <el-option label="装修业主 / 准业主" value="装修业主 / 准业主"></el-option>
            <el-option label="美学爱好者 / 普通观展观众" value="美学爱好者 / 普通观展观众"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
          <!-- 如果选了其他，显示输入框 -->
          <el-input
              v-if="formData.identity === '其他'"
              v-model="formData.other_identity"
              placeholder="请输入您的具体身份"
              class="mt-10"
          ></el-input>
        </el-form-item>

        <!-- 2. 观展目的 (多选) -->
        <el-form-item label="2. 您本次观展的主要目的是？（可多选）" prop="purpose">
          <el-checkbox-group v-model="formData.purpose">
            <el-checkbox label="行业学习、获取最新设计趋势">行业学习、获取最新设计趋势</el-checkbox>
            <el-checkbox label="寻找新品、材料、软装、合作品牌">寻找新品、材料、软装、合作品牌</el-checkbox>
            <el-checkbox label="对接设计师、行业资源、商务交流">对接设计师、行业资源、商务交流</el-checkbox>
            <el-checkbox label="打卡观展、感受艺术氛围">打卡观展、感受艺术氛围</el-checkbox>
            <el-checkbox label="课程/论坛/沙龙学习">课程/论坛/沙龙学习</el-checkbox>
            <el-checkbox label="巩固合作伙伴关系">巩固合作伙伴关系</el-checkbox>
            <el-checkbox label="参加展会同期活动">参加展会同期活动</el-checkbox>
            <el-checkbox label="评估展会下次参展">评估展会下次参展</el-checkbox>
            <el-checkbox label="媒体资讯报道">媒体资讯报道</el-checkbox>
            <el-checkbox label="其他">其他</el-checkbox>
          </el-checkbox-group>
          <!-- 如果选了其他，显示输入框 -->
          <el-input
              v-if="formData.purpose.includes('其他')"
              v-model="formData.other_purpose_content"
              placeholder="请补充您的其他目的"
              class="mt-10"
          ></el-input>
        </el-form-item>

        <!-- 3. 获知途径 (多选) -->
        <el-form-item label="3. 得知本次展会的途径 (可多选)" prop="channels">
          <el-checkbox-group v-model="formData.channels">
            <el-checkbox label="主办方官网">主办方官网</el-checkbox>
            <el-checkbox label="主办方微信公众号">主办方微信公众号</el-checkbox>
            <el-checkbox label="主办方邮箱">主办方邮箱</el-checkbox>
            <el-checkbox label="主办方短信">主办方短信</el-checkbox>
            <el-checkbox label="抖音/今日头条">抖音/今日头条</el-checkbox>
            <el-checkbox label="户外广告牌">户外广告牌</el-checkbox>
            <el-checkbox label="媒体刊物报道/新闻">媒体刊物报道/新闻</el-checkbox>
            <el-checkbox label="行业协会/城市运营机构邀请">行业协会/城市运营机构邀请</el-checkbox>
            <el-checkbox label="媒体机构邀请">媒体机构邀请</el-checkbox>
            <el-checkbox label="展商邀请/推荐">展商邀请/推荐</el-checkbox>
            <el-checkbox label="同行/同事/朋友推荐">同行/同事/朋友推荐</el-checkbox>
            <el-checkbox label="学校组织推荐">学校组织推荐</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <!-- 4. 预计参观日期 (多选) -->
        <el-form-item label="4. 您预计的参观日期 (可多选)" prop="dates">
          <el-checkbox-group v-model="formData.dates">
            <el-checkbox label="2026-12-18">2026年12月18日 (星期五)</el-checkbox>
            <el-checkbox label="2026-12-19">2026年12月19日 (星期六)</el-checkbox>
            <el-checkbox label="2026-12-20">2026年12月20日 (星期日)</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <!-- 提交按钮 -->
        <div class="submit-area">
          <el-button type="primary" :loading="submitting" @click="submitForm" size="large"
                     style="width: 100%; font-size: 16px;">
            提交登记
          </el-button>
        </div>

      </el-form>
    </el-card>

    <!-- 【新增】提交成功后的二维码弹窗 -->
    <el-dialog title="登记成功" :visible.sync="dialogVisible" width="400px">
      <div style="text-align: center;">
        <p>请截图保存此二维码</p>

        <!-- 直接使用 img 标签 -->
        <!-- v-if 确保有数据时才渲染，避免显示破图图标 -->
        <div v-if="ticketInfo.qr_image" style="margin: 5px auto; padding: 5px; background: #fff; display: inline-block; border: 1px solid #eee;">
          <img :src="ticketInfo.qr_image" alt="门票二维码" style="width: 300px; height: 300px; display: block;" />
        </div>

        <p class="code-text">验券码: {{ ticketInfo.ticket_code }}</p>
      </div>
      <span slot="footer">
    <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  data() {
    // 自定义校验规则：身份证
    const validateIdCard = (rule, value, callback) => {
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!value) {
        return callback(new Error('请输入身份证号'));
      } else if (!reg.test(value)) {
        return callback(new Error('身份证号格式不正确'));
      } else {
        callback();
      }
    };

    // 自定义校验规则：多选题必填
    const validateCheckboxGroup = (rule, value, callback) => {
      if (value.length === 0) {
        return callback(new Error('请至少选择一项'));
      } else {
        callback();
      }
    };

    return {
      submitting: false,
      isCountingDown: false,
      countdown: 60,
      timer: null,
      // 【新增】二维码弹窗状态与验券码
      dialogVisible: false,
      ticketInfo: {
        code: '',
        qr_image: ''
      },
      formData: {
        // 基础信息
        name: '',
        phone: '',
        code: '',
        company: '',
        jobTitle: '',
        idCard: '',
        address: '',

        // 问卷信息
        identity: '',         // 单选
        other_identity: '',   // 身份-其他备注
        purpose: [],          // 目的-多选
        other_purpose_content: '', // 目的-其他备注
        channels: [],         // 途径-多选
        dates: []             // 日期-多选
      },

      rules: {
        name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur'}
        ],
        code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
        company: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
        jobTitle: [{required: true, message: '请输入职务', trigger: 'blur'}],
        idCard: [{required: true, validator: validateIdCard, trigger: 'blur'}],
        address: [{required: true, message: '请输入地址', trigger: 'blur'}],

        // 问卷校验
        identity: [{required: true, message: '请选择身份类型', trigger: 'change'}],
        purpose: [{required: true, validator: validateCheckboxGroup, trigger: 'change'}],
        channels: [{required: true, validator: validateCheckboxGroup, trigger: 'change'}],
        dates: [{required: true, validator: validateCheckboxGroup, trigger: 'change'}]
      }
    };
  },
  methods: {
    // 获取验证码
    getCode() {
      this.$refs.regForm.validateField('phone', (errorMessage) => {
        if (!errorMessage) {
          // 模拟请求后端接口
          axios.post('https://www.shdesignweek.com/api/login/get_code', {
            mobile: this.formData.phone
          }).then(res => {
            // 这里需要根据实际后端返回结构调整，假设成功是 code: 200
            if (res) {
              this.$message.success('验证码已发送');
              this.startCountdown();
            } else {
              this.$message.error(res.data.msg || '发送失败');
            }
          }).catch(err => {
            console.error(err);
            this.startCountdown();
          });
        }
      });
    },

    startCountdown() {
      this.isCountingDown = true;
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.isCountingDown = false;
        }
      }, 1000);
    },
    // 提交表单
    submitForm() {
      // 基础校验：检查是否勾选隐私协议
      // if (!this.agreedPrivacy) {
      //   this.$message.warning('请先阅读并同意《隐私协议》');
      //   return;
      // }

      // 2. Element UI 表单整体校验
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          this.submitting = true; // 开启按钮 loading 状态

          // 3. 构造最终提交的数据对象
          const submitData = {
            // 基础实名信息
            name: this.formData.name,
            phone: this.formData.phone,
            code: this.formData.code,
            company_name: this.formData.company,
            job_title: this.formData.jobTitle,
            id_card: this.formData.idCard,
            address: this.formData.address,

            // 问卷调研信息
            identity_type: this.formData.identity,
            identity_other: this.formData.identity === 'other' ? this.formData.other_identity : '',

            // 多选字段：使用 JSON.stringify 转为字符串传给后端
            visit_purpose: this.formData.purpose,
            purpose_other: this.formData.purpose.includes('other_purpose') ? this.formData.other_purpose_content : '',

            know_channel: this.formData.channels,
            visit_dates: this.formData.dates
          };

          axios.post('https://www.shdesignweek.com/api/registration/add', submitData)
              .then(res => {
                if (res.data.code === 200) {
                  this.$message.success( '登记成功！');
                  this.ticketInfo = {
                    ticket_code: res.data.data.ticket_code,
                    qr_image: res.data.data.qr_image // 后端传来的 base64
                  };
                  this.dialogVisible = true; // 打开弹窗
                  // 清空表单数据
                  this.formData = {
                    name: '',
                    phone: '',
                    code: '',
                    company: '',
                    jobTitle: '',
                    idCard: '',
                    address: '',
                    identity: '',
                    other_identity: '',
                    purpose: [],
                    other_purpose_content: '',
                    channels: [],
                    dates: []
                  };
                  // 重置表单校验状态
                  this.$nextTick(() => {
                    this.$refs.regForm.clearValidate();
                  });
                } else {
                  this.$message.error(res.data.msg || '提交失败，请稍后重试');
                }
              })
              .catch(err => {
                console.error('提交失败:', err);
                this.$message.error('网络异常，请检查网络连接后重试');
              })
              .finally(() => {
                this.submitting = false;
              });
        } else {
          this.$message.error('请检查并填写所有必填项');
          return false;
        }


      });
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style scoped>
.registration-page {
  max-width: 800px;
  margin: 20px auto;
  padding: 0 15px;
}

.header-box {
  text-align: center;
}

.sub-title {
  color: #909399;
  font-size: 14px;
  display: block;
  margin-top: 5px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  border-left: 4px solid #409eff;
  padding-left: 10px;
  margin-bottom: 20px;
  background-color: #f5f7fa;
  padding-top: 5px;
  padding-bottom: 5px;
}

.mt-40 {
  margin-top: 40px;
}

.mt-10 {
  margin-top: 10px;
}

.submit-area {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px dashed #ebeef5;
}

/* 适配移动端 Checkbox 间距 */
.el-checkbox {
  margin-right: 15px;
  margin-bottom: 10px;
  display: inline-block;
  width: 100%; /* 手机端强制换行 */
}

@media (min-width: 768px) {
  .el-checkbox {
    width: auto; /* PC端自动宽度 */
  }
}
</style>